import { useEffect, useMemo, useState, useRef } from 'react';

import { db } from 'src/utils/firebase';
import { useSnackbar } from 'notistack';

export const usePendingTasks = (userId) => {
  const [pendingTasks, setPendingTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const prevTaskCountRef = useRef(0); // Track the previous task count
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let unsubscribe;

    if (!userId) {
      setPendingTasks([]);
      setLoading(false);
    } else {
      setLoading(true);
      const query = db
        .collection('tasks')
        .where('user_id', '==', userId)
        .where('status', '==', 'pending')
        .orderBy('timestamp', 'desc')
        .limit(1);

      unsubscribe = query.onSnapshot((snapshot) => {
        const tasks = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          tasks.push({ id: doc.id, ...data });
        });

        setPendingTasks(tasks);
        setLoading(false);

        // Check if the number of tasks has increased
        if (tasks.length > prevTaskCountRef.current) {
          enqueueSnackbar('Your dough is rising! Changes are processing...', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
        prevTaskCountRef.current = tasks.length; // Update previous task count
      });
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [userId, enqueueSnackbar]);

  const hasPendingTasks = useMemo(() => pendingTasks.length > 0, [pendingTasks]);

  return { pendingTasks, hasPendingTasks, loading };
};
